import React, { useState, useEffect } from "react";
import { _t, getCookie } from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import { toast } from "react-toastify";

const UpdateDeliveryChargeModal = ({
  deliveryChargeModalItem,
  setDeliveryChargeModalItem,
  setPaginatedSubmittedOrders,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [serviceCharge, setServiceCharge] = useState(
    deliveryChargeModalItem?.service_charge || 0
  );
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (deliveryChargeModalItem) {
      setServiceCharge(deliveryChargeModalItem.service_charge || 0);
      setReason("");
    }
  }, [deliveryChargeModalItem]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      toast.error(_t(t("Reason is mandatory")));
      return;
    }

    setLoading(true);
    const url = BASE_URL + "/settings/update-orders-field";
    const payload = {
      id: deliveryChargeModalItem?.id,
      service_charge: serviceCharge,
      refund_reason: reason,
    };

    axios
      .post(url, payload, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLoading(false);
        if (res.data) {
          toast.success(_t(t("Delivery charges updated successfully")), {
            position: "bottom-center",
            closeButton: false,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          setPaginatedSubmittedOrders(1)
        }
        setDeliveryChargeModalItem(null);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(_t(t("Please try again")), {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        setDeliveryChargeModalItem(null);
      });
  };

  return (
    <div
      className={`modal fade ${deliveryChargeModalItem ? "showing" : ""}`}
      id="updateDeliveryCharge"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header align-items-center">
            <div className="w-100 d-flex align-items-center justify-content-center">
              <div className="rider-text">{_t(t("Update Delivery Charges"))}</div>
              <button
                type="button"
                className="btn-close"
                onClick={() => setDeliveryChargeModalItem(null)}
              ></button>
            </div>
          </div>
          <div className="modal-body">
            <form
              className="border my-2 alert-success rounded-lg"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <div className="table-text ml-2 py-2">
                {_t(t("Delivery Charge"))}
              </div>
              <div className="addons-list__item mx-2 mb-1">
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  name="service_charge"
                  placeholder={_t(t("Delivery Charge"))}
                  className="form-control lg-text pl-2"
                  value={serviceCharge}
                  onChange={(e) => setServiceCharge(e.target.value)}
                  required
                />
              </div>

              <div className="table-text ml-2 py-2">
                {_t(t("Reason"))} <span className="text-danger">*</span>
              </div>
              <div className="addons-list__item mx-2 mb-1">
                <textarea
                  name="reason"
                  placeholder={_t(t("Enter reason"))}
                  className="form-control lg-text pl-2"
                  rows="3"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  required
                ></textarea>
              </div>

              <div className="pb-2 pl-2 mt-3 d-flex justify-content-center mb-2">
                <button
                  disabled={loading}
                  className="btn btn-sm btn-success text-center px-3 text-uppercase"
                  type="submit"
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    _t(t("Update"))
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateDeliveryChargeModal;
